export default __webpack_public_path__ + "static/media/logo_320_120.24018b26.png";